import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Loader from "../../Loader";
import FieldRenderer from "../FieldRenderer";

// Set up the PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({
  documentData,
  pageNumber,
  scale,
  placedFields,
  modalSettingsObj,
  getFieldConfig,
  getFieldSettings,
  handleMouseDown,
  handleDuplicateField,
  handleSettingsClick,
  handleDeleteField,
  handleFieldChange,
  handleProvideESignature,
  setPlacedFields,
  onDocumentLoadSuccess,
  onDocumentLoadError,
  isPdfLoading,
}) => {
  return (
    <div className="pdf-canvas-container">
      <div className="pdf-page-wrapper">
        {documentData?.design_url ? (
          <Document
            file={`${documentData?.design_url}`}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading={<Loader />}
            error={null}
            noData={null}
          >
            <Page
              pageNumber={pageNumber}
              scale={scale}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              className="pdf-page"
            />
          </Document>
        ) : (
          <Loader />
        )}
        {!isPdfLoading && (
          <FieldRenderer
            fields={placedFields}
            pageNumber={pageNumber}
            scale={scale}
            modalSettingsObj={modalSettingsObj}
            getFieldConfig={getFieldConfig}
            getFieldSettings={getFieldSettings}
            handleMouseDown={handleMouseDown}
            handleDuplicateField={handleDuplicateField}
            handleSettingsClick={handleSettingsClick}
            handleDeleteField={handleDeleteField}
            handleFieldChange={handleFieldChange}
            handleProvideESignature={handleProvideESignature}
            placedFields={placedFields}
            setPlacedFields={setPlacedFields}
          />
        )}
      </div>
    </div>
  );
};

export default PDFViewer;
